module.exports = __webpack_public_path__ + "static/UT-d15262e74eac58b95036bda030ad84f7.svg";